"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomStylesPanel = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const ArgsPane_1 = require("@jsonjoy.com/ui/lib/4-card/ContextMenu/ArgsPane");
const context_1 = require("@jsonjoy.com/ui/lib/4-card/Popup/context");
const context_2 = require("../context");
const settings_1 = require("./settings");
const font_family_1 = tslib_1.__importDefault(require("iconista/lib/react/radix/font-family"));
const font_size_1 = tslib_1.__importDefault(require("iconista/lib/react/radix/font-size"));
const stretching_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/stretching"));
const glasses_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/glasses"));
const ligature_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/ligature"));
const hash_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/hash"));
const line_height_1 = tslib_1.__importDefault(require("iconista/lib/react/radix/line-height"));
const letter_spacing_1 = tslib_1.__importDefault(require("iconista/lib/react/radix/letter-spacing"));
const letter_spacing_2 = tslib_1.__importDefault(require("iconista/lib/react/radix/letter-spacing"));
const kerning_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/kerning"));
const font_bold_1 = tslib_1.__importDefault(require("iconista/lib/react/radix/font-bold"));
const italic_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/italic"));
const letter_case_uppercase_1 = tslib_1.__importDefault(require("iconista/lib/react/radix/letter-case-uppercase"));
const letter_case_lowercase_1 = tslib_1.__importDefault(require("iconista/lib/react/radix/letter-case-lowercase"));
const underline_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/underline"));
const highlighter_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/highlighter"));
const paintbrush_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/paintbrush"));
const paint_bucket_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/paint-bucket"));
const ban_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/ban"));
const ligature_2 = tslib_1.__importDefault(require("iconista/lib/react/lucide/ligature"));
const sparkles_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/sparkles"));
const scroll_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/scroll"));
const hash_2 = tslib_1.__importDefault(require("iconista/lib/react/lucide/hash"));
const feather_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/feather"));
const rows_2_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/rows-2"));
const table_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/table"));
const wand_sparkles_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/wand-sparkles"));
const equal_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/equal"));
const FfIcon = (props) => React.createElement(font_family_1.default, { width: 15, height: 15, ...props });
const FzIcon = (props) => React.createElement(font_size_1.default, { width: 15, height: 15, ...props });
const FsIcon = (props) => React.createElement(stretching_1.default, { width: 15, height: 15, ...props });
const OsIcon = (props) => React.createElement(glasses_1.default, { width: 15, height: 15, ...props });
const LigIcon = (props) => React.createElement(ligature_1.default, { width: 15, height: 15, ...props });
const NvIcon = (props) => React.createElement(hash_1.default, { width: 15, height: 15, ...props });
const LhIcon = (props) => React.createElement(line_height_1.default, { width: 15, height: 15, ...props });
const LsIcon = (props) => React.createElement(letter_spacing_1.default, { width: 15, height: 15, ...props });
const WsIcon = (props) => React.createElement(letter_spacing_2.default, { width: 15, height: 15, ...props });
const KrnIcon = (props) => React.createElement(kerning_1.default, { width: 15, height: 15, ...props });
const FwIcon = (props) => React.createElement(font_bold_1.default, { width: 15, height: 15, ...props });
const ItIcon = (props) => React.createElement(italic_1.default, { width: 16, height: 16, ...props });
const CapsIcon = (props) => (React.createElement(letter_case_uppercase_1.default, { width: 15, height: 15, ...props }));
const SmcpIcon = (props) => (React.createElement(letter_case_lowercase_1.default, { width: 15, height: 15, ...props }));
const UoIcon = (props) => React.createElement(underline_1.default, { width: 15, height: 15, ...props });
const DtIcon = (props) => React.createElement(highlighter_1.default, { width: 15, height: 15, ...props });
const FgIcon = (props) => React.createElement(paintbrush_1.default, { width: 16, height: 16, ...props });
const BgIcon = (props) => React.createElement(paint_bucket_1.default, { width: 16, height: 16, ...props });
// Small (14px) icons used inside enum/select option lists.
const BanIcon = (props) => React.createElement(ban_1.default, { width: 14, height: 14, ...props });
const LigatureSmallIcon = (props) => (React.createElement(ligature_2.default, { width: 14, height: 14, ...props }));
const SparklesIcon = (props) => (React.createElement(sparkles_1.default, { width: 14, height: 14, ...props }));
const ScrollIcon = (props) => (React.createElement(scroll_1.default, { width: 14, height: 14, ...props }));
const HashIcon = (props) => (React.createElement(hash_2.default, { width: 14, height: 14, ...props }));
const FeatherIcon = (props) => (React.createElement(feather_1.default, { width: 14, height: 14, ...props }));
const Rows2Icon = (props) => (React.createElement(rows_2_1.default, { width: 14, height: 14, ...props }));
const TableIcon = (props) => (React.createElement(table_1.default, { width: 14, height: 14, ...props }));
const WandIcon = (props) => (React.createElement(wand_sparkles_1.default, { width: 14, height: 14, ...props }));
const EqualIcon = (props) => (React.createElement(equal_1.default, { width: 14, height: 14, ...props }));
/**
 * Unwrap a `defaultable` arg value. The args pane stores them as
 * `{def: boolean, value: T}` while non-defaultable keys store the raw value.
 * Returns `undefined` when the user has left the field at "default".
 */
const pick = (raw) => {
    if (raw && typeof raw === 'object' && 'def' in raw) {
        const { def, value } = raw;
        return def ? undefined : value;
    }
    return raw;
};
const CustomStylesPanel = ({ closePopup }) => {
    const [t] = (0, use_t_1.useT)();
    const mutxt = (0, context_2.useMuTxt)();
    const popup = (0, context_1.usePopup)();
    const cs = mutxt.customStyle.cs.use();
    const onCancel = React.useCallback(() => {
        if (closePopup)
            closePopup();
        else
            popup?.close();
    }, [closePopup, popup]);
    const item = React.useMemo(() => ({ name: t('Custom Styles'), compact: true }), [t]);
    const params = React.useMemo(() => {
        const defable = (key, fallback) => ({
            initialDef: cs[key] === undefined,
            initialValue: cs[key] !== undefined ? cs[key] : fallback,
            default: fallback,
        });
        return [
            { name: t('Font'), heading: true, collapsible: true },
            {
                kind: 'select',
                id: 'ff',
                name: t('Typeface'),
                defaultable: true,
                searchPlaceholder: t('Find font…'),
                icon: () => React.createElement(FfIcon, null),
                options: settings_1.FONT_OPTIONS,
                ...defable('ff', settings_1.DEFAULTS.ff),
            },
            {
                kind: 'num',
                id: 'fz',
                name: t('Font size'),
                defaultable: true,
                min: 6,
                max: 96,
                step: 0.1,
                decimals: 1,
                dragSensitivity: 0.1,
                dragAxis: 'y',
                icon: () => React.createElement(FzIcon, null),
                ...defable('fz', settings_1.DEFAULTS.fz),
            },
            {
                kind: 'num',
                id: 'fs',
                name: t('Font stretch'),
                defaultable: true,
                min: 50,
                max: 200,
                step: 5,
                dragSensitivity: 0.5,
                icon: () => React.createElement(FsIcon, null),
                ...defable('fs', settings_1.DEFAULTS.fs),
            },
            {
                kind: 'bool',
                id: 'os',
                name: t('Optical sizing'),
                defaultable: true,
                icon: () => React.createElement(OsIcon, null),
                ...defable('os', settings_1.DEFAULTS.os),
            },
            {
                kind: 'select',
                id: 'lig',
                name: t('Ligatures'),
                defaultable: true,
                icon: () => React.createElement(LigIcon, null),
                options: [
                    { name: t('None'), id: 'none', icon: () => React.createElement(BanIcon, null) },
                    { name: t('Common'), id: 'common', icon: () => React.createElement(LigatureSmallIcon, null) },
                    { name: t('Discretionary'), id: 'discretionary', icon: () => React.createElement(SparklesIcon, null) },
                    { name: t('Historical'), id: 'historical', icon: () => React.createElement(ScrollIcon, null) },
                ],
                ...defable('lig', settings_1.DEFAULTS.lig),
            },
            {
                kind: 'enum',
                id: 'nv',
                name: t('Numeric variant'),
                defaultable: true,
                icon: () => React.createElement(NvIcon, null),
                options: [
                    { name: t('Default'), id: 'normal', icon: () => React.createElement(HashIcon, null) },
                    { name: t('Oldstyle'), id: 'oldstyle', icon: () => React.createElement(FeatherIcon, null) },
                    { name: t('Lining'), id: 'lining', icon: () => React.createElement(Rows2Icon, null) },
                    { name: t('Tabular'), id: 'tabular', icon: () => React.createElement(TableIcon, null) },
                ],
                ...defable('nv', settings_1.DEFAULTS.nv),
            },
            { name: t('Spacing'), heading: true, collapsible: true },
            {
                kind: 'num',
                id: 'lh',
                name: t('Line height'),
                defaultable: true,
                min: 0.5,
                max: 3,
                step: 0.1,
                dragSensitivity: 0.01,
                dragAxis: 'y',
                icon: () => React.createElement(LhIcon, null),
                ...defable('lh', settings_1.DEFAULTS.lh),
            },
            {
                kind: 'num',
                id: 'ls',
                name: t('Letter spacing'),
                defaultable: true,
                min: -0.2,
                max: 0.4,
                step: 0.01,
                dragSensitivity: 0.005,
                icon: () => React.createElement(LsIcon, null),
                ...defable('ls', settings_1.DEFAULTS.ls),
            },
            {
                kind: 'num',
                id: 'ws',
                name: t('Word spacing'),
                defaultable: true,
                min: -0.5,
                max: 1,
                step: 0.01,
                dragSensitivity: 0.01,
                icon: () => React.createElement(WsIcon, null),
                ...defable('ws', settings_1.DEFAULTS.ws),
            },
            {
                kind: 'enum',
                id: 'krn',
                name: t('Kerning'),
                defaultable: true,
                icon: () => React.createElement(KrnIcon, null),
                options: [
                    { name: t('Auto'), id: 'auto', icon: () => React.createElement(WandIcon, null) },
                    { name: t('Normal'), id: 'normal', icon: () => React.createElement(EqualIcon, null) },
                    { name: t('None'), id: 'none', icon: () => React.createElement(BanIcon, null) },
                ],
                ...defable('krn', settings_1.DEFAULTS.krn),
            },
            { name: t('Style'), heading: true, collapsible: true },
            {
                kind: 'num',
                id: 'fw',
                name: t('Font weight'),
                defaultable: true,
                min: 100,
                max: 900,
                step: 100,
                dragSensitivity: 4,
                icon: () => React.createElement(FwIcon, null),
                ...defable('fw', settings_1.DEFAULTS.fw),
            },
            {
                kind: 'bool',
                id: 'it',
                name: t('Italic'),
                defaultable: true,
                icon: () => React.createElement(ItIcon, null),
                ...defable('it', settings_1.DEFAULTS.it),
            },
            {
                kind: 'bool',
                id: 'caps',
                name: t('Large caps'),
                defaultable: true,
                icon: () => React.createElement(CapsIcon, null),
                ...defable('caps', settings_1.DEFAULTS.caps),
            },
            {
                kind: 'bool',
                id: 'smcp',
                name: t('Small caps'),
                defaultable: true,
                icon: () => React.createElement(SmcpIcon, null),
                ...defable('smcp', settings_1.DEFAULTS.smcp),
            },
            {
                kind: 'num',
                id: 'uo',
                name: t('Underline offset'),
                defaultable: true,
                min: 0,
                max: 0.5,
                step: 0.01,
                decimals: 2,
                dragSensitivity: 0.0015,
                dragAxis: 'y',
                icon: () => React.createElement(UoIcon, null),
                ...defable('uo', settings_1.DEFAULTS.uo),
            },
            {
                kind: 'num',
                id: 'dt',
                name: t('Decoration width'),
                defaultable: true,
                min: 0.01,
                max: 0.3,
                step: 0.01,
                decimals: 2,
                dragAxis: 'y',
                dragSensitivity: 0.003,
                icon: () => React.createElement(DtIcon, null),
                ...defable('dt', settings_1.DEFAULTS.dt),
            },
            { name: t('Color'), heading: true, collapsible: true },
            {
                kind: 'color',
                id: 'fg',
                name: t('Text color'),
                defaultable: true,
                alpha: true,
                icon: () => React.createElement(FgIcon, null),
                ...defable('fg', settings_1.DEFAULTS.fg),
            },
            {
                kind: 'color',
                id: 'bg',
                name: t('Background'),
                defaultable: true,
                alpha: true,
                icon: () => React.createElement(BgIcon, null),
                ...defable('bg', settings_1.DEFAULTS.bg),
            },
        ];
    }, [t, cs]);
    const onChange = React.useCallback((_list, map) => {
        const next = {};
        const numKeys = ['fz', 'fs', 'fw', 'lh', 'ls', 'ws', 'uo', 'dt'];
        const strKeys = ['ff', 'lig', 'nv', 'krn', 'fg', 'bg'];
        const boolKeys = ['os', 'it', 'caps', 'smcp'];
        for (const k of numKeys) {
            const v = pick(map[k]);
            if (v !== undefined && Number.isFinite(v))
                next[k] = v;
        }
        for (const k of strKeys) {
            const v = pick(map[k]);
            if (v)
                next[k] = v;
        }
        for (const k of boolKeys) {
            const v = pick(map[k]);
            if (v !== undefined)
                next[k] = v;
        }
        mutxt.customStyle.replace(next);
    }, [mutxt]);
    return React.createElement(ArgsPane_1.ArgsPane, { inline: true, item: item, params: params, onCancel: onCancel, onChange: onChange });
};
exports.CustomStylesPanel = CustomStylesPanel;
